import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  const forList = ['Mujeres que han sido rechazadas para un préstamo de auto o hipoteca.', 'Hispanas que quieren tomar el control de sus finanzas sin depender de terceros.', 'Personas con errores de identidad o nombres similares en su reporte.', 'Cualquier persona cansada de pagar intereses abusivos por culpa de un número.'];
  const notForList = ['Personas que buscan borrar deudas legítimas y recientes sin seguir un proceso legal.', 'Quienes esperan resultados mágicos de la noche a la mañana sin enviar ni una carta.'];
  return <section className="py-24 bg-brand-cream relative" data-id="element-182">
      <div className="container mx-auto px-6" data-id="element-183">
        <FadeIn data-id="element-184">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-dark mb-16" data-id="element-185">
            ¿Es para ti?
          </h2>
        </FadeIn>

        <div className="flex flex-col md:flex-row gap-8 max-w-6xl mx-auto" data-id="element-186">
          {/* FOR Column */}
          <FadeIn direction="right" className="flex-1" data-id="element-187">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border-t-8 border-brand-gold h-full" data-id="element-188">
              <h3 className="text-2xl font-bold text-brand-dark mb-8 flex items-center gap-3" data-id="element-189">
                <span className="bg-green-100 text-green-600 p-2 rounded-full" data-id="element-190">
                  <Check className="w-6 h-6" data-id="element-191" />
                </span>
                SÍ ES PARA TI SI...
              </h3>
              <ul className="space-y-6" data-id="element-192">
                {forList.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-193">
                    <Check className="w-6 h-6 text-brand-gold flex-shrink-0 mt-1" data-id="element-194" />
                    <span className="text-gray-700 font-medium" data-id="element-195">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* NOT FOR Column */}
          <FadeIn direction="left" delay={0.2} className="flex-1" data-id="element-196">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border-t-8 border-brand-rose h-full opacity-90" data-id="element-197">
              <h3 className="text-2xl font-bold text-brand-dark mb-8 flex items-center gap-3" data-id="element-198">
                <span className="bg-red-100 text-red-600 p-2 rounded-full" data-id="element-199">
                  <X className="w-6 h-6" data-id="element-200" />
                </span>
                NO ES PARA TI SI...
              </h3>
              <ul className="space-y-6" data-id="element-201">
                {notForList.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-202">
                    <X className="w-6 h-6 text-brand-rose flex-shrink-0 mt-1" data-id="element-203" />
                    <span className="text-gray-600" data-id="element-204">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}